import { render } from "./CartModel.vue?vue&type=template&id=535cf6a4&scoped=true"
import script from "./CartModel.vue?vue&type=script&lang=js"
export * from "./CartModel.vue?vue&type=script&lang=js"

import "./CartModel.vue?vue&type=style&index=0&id=535cf6a4&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535cf6a4"]])

export default __exports__